export default __webpack_public_path__ + "static/media/roulette.1bc950d9.webp";